import React from "react";
import Alert, { ALERT_DANGER } from "../Alert";

interface Error {
	code: string;
	message: string;
}

interface ErrorProps {
	errors: [Error];
}

export default function Error({ errors }: ErrorProps) {
	return (
		<Alert severity={ALERT_DANGER}>
			<p>Below errors have been found:</p>
			<ul>
				{errors.map(({ code, message }) => (
					<li key={code}>
						<b>{code}</b>
						{` - ${message}`}
					</li>
				))}
			</ul>
		</Alert>
	);
}
